import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  title: {
    id: 'commerce.credit-card-base.form.error.title',
    defaultMessage: 'Problem connecting',
    description: 'The title in a section message for the credit card form error'
  },
  retry: {
    id: 'commerce.credit-card-base.form.error.retry',
    defaultMessage: 'Try again',
    description: 'A section message button action for retrying the credit card form'
  },
  contactSupport: {
    id: 'commerce.credit-card-base.form.error.contactSupport',
    defaultMessage: 'Contact support',
    description: 'A section message button action for contacting support'
  },
  content: {
    id: 'commerce.credit-card-base.form.error.content',
    defaultMessage: "We're sorry, we can't load the credit card form right now.",
    description: 'The main content in a section message for a generic credit card form error'
  }
});